var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecognitions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.468 14.4043L18.2376 16.5186L19.7767 20.7472L16.7434 19.7229L15.0782 22.4573L13.5391 18.2287L13.1543 17.1716",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53199 14.4043L5.76245 16.5186L4.22336 20.7472L7.25663 19.7229L8.92182 22.4573L10.4609 18.2287L10.8457 17.1716",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1L14.0795 3.03282L16.9443 2.62336L17.4442 5.50306L20 6.87336L18.7294 9.5L20 12.1266L17.4442 13.4969L16.9443 16.3766L14.0795 15.9672L12 18L9.92051 15.9672L7.05573 16.3766L6.55583 13.4969L4 12.1266L5.27064 9.5L4 6.87336L6.55583 5.50306L7.05573 2.62336L9.92051 3.03282L12 1Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecognitions);
export default __webpack_public_path__ + "static/media/recognitions.e6f405467453b6f38e30b9f1979d91d3.svg";
export { ForwardRef as ReactComponent };